import storageUtil from "./storageUtil";

let messageUtil = {
    loadMessageHistory(){
        return storageUtil.getLocalMainMsg()
    },
    saveMessageHistory(messageList){
        if (messageList.length > 100){
            messageList.slice(0,99)
        }
        storageUtil.setLocalMainMsg(JSON.stringify(messageList))
    },

    loadNewMessage(messageList,localMessageList){
        if (localMessageList == null){
            return this.saveAndFormat(messageList)
        }
        if (messageList == null){
            return this.saveAndFormat(localMessageList)
        }
        let ret = []
        let mapLocal = new Map()
        let mapNew = new Map()
        for (let i = 0; i < localMessageList.length; i++) {
            mapLocal.set(this.connectStr(localMessageList[i].sendId,localMessageList[i].countType),localMessageList[i].unRead)
        }

        for (let i = 0; i < messageList.length; i++) {
            let key = this.connectStr(messageList[i].sendId,messageList[i].countType)
            if (mapLocal.has(key)){
                messageList[i].unRead += mapLocal.get(key)
                mapNew.set(key,null)
            }
            ret.push(messageList[i])
        }

        for (let i = 0; i < localMessageList.length; i++) {
            let key = this.connectStr(localMessageList[i].sendId,localMessageList[i].countType)
            if (!mapNew.has(key)){
                ret.push(localMessageList[i])
            }
        }

        return this.saveAndFormat(ret)
    },

    onlySaveToReadByZero(messageList,localMessageList,userCount,type){
        if (localMessageList == null){
            return this.saveAndFormat(messageList)
        }
        if (messageList == null){
            return this.saveAndFormat(localMessageList)
        }
        let ret = []
        let mapLocal = new Map()
        let mapNew = new Map()
        for (let i = 0; i < localMessageList.length; i++) {
            mapLocal.set(this.connectStr(localMessageList[i].sendId,localMessageList[i].countType),localMessageList[i].unRead)
        }

        for (let i = 0; i < messageList.length; i++) {
            let key = this.connectStr(messageList[i].sendId,messageList[i].countType)
            if (mapLocal.has(key)){
                messageList[i].unRead += mapLocal.get(key)
                mapNew.set(key,null)
            }
            ret.push(messageList[i])
        }
        for (let i = 0; i < localMessageList.length; i++) {
            let key = this.connectStr(localMessageList[i].sendId,localMessageList[i].countType)
            if (!mapNew.has(key)){
                ret.push(localMessageList[i])
            }
        }
        ret.forEach(t=>{
            if (userCount === t.sendId && type === t.countType){
                t.unRead = 0
            }
        })
        this.saveMessageHistory(ret)
    },

    saveAndFormat(ret){
        let dateStr = this.getFormatDate()
        this.saveMessageHistory(ret)
        for (let i = 0; i < ret.length; i++) {
            ret[i].showTime = this.resolveStr(dateStr,ret[i].createTime)
        }
        return ret
    },

    connectStr(strOne,strTwo){
        return strOne + "-" + strTwo
    },
    getFormatDate(){
        let date = new Date();
        let year = date.getFullYear()
        let month = date.getMonth() + 1 < 10  ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1)
        let day = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate()
        let fill = "000000000"
        return  String(year) + String(month) + String(day) + fill
    },
    resolveStr(date,str){
        if (!str || str.length !== 17){
            return ""
        }
        if (str < date){
            return str.substring(4,6) + "-" + str.substring(6,8)
        }

        return str.substring(8,10) + ":" + str.substring(10,12)

    },

    removeLocalMainMsg(msg,index) {
      msg.splice(index,1)
      this.saveMessageHistory(msg)
    },

    stickLocalMainMsg(msg,index){
        let temp = msg[index]
        msg.splice(index,1)
        msg.unshift(temp)
        this.saveMessageHistory(msg)
    },

    singUnReadLocalMainMsg(msg,index){
        msg[index].unRead = 1
        this.saveMessageHistory(msg)
    },


}

export default messageUtil
